import {select} from '@ngneat/elf';

import {statisticsStore} from '@store/statistics/statistics.store';
import {
  getCurveChartDataSource,
  getEvolutionOfOperationsDataSource,
  getExecutionCountAll,
  getExecutionCountOther,
  getExecutionCountPickup,
  getExecutionCountProcessingValo,
  getExecutionCountRenting,
  getInvoicingProgression,
  getMarginByLineDataSource,
  getMostProfitableClients,
  getTotalTurnoverNewDataSource,
  getTurnoverAndPurchaseDataSource,
  getTurnoverChargesServiceKind,
  getTurnoverChargesValo,
  getValoWeightByWasteFamily
} from '@store/statistics/statistics.requests';

export class StatisticsQuery {
  store = statisticsStore;

  filters$ = this.store.pipe(select((state) => state.filters));

  evolutionOfOperations$ = getEvolutionOfOperationsDataSource.data$();

  totalTurnoverNew$ = getTotalTurnoverNewDataSource.data$();
  donutChart$ = getInvoicingProgression.data$();
  curveChart$ = getCurveChartDataSource.data$();
  marginByLine$ = getMarginByLineDataSource.data$();
  turnoverAndPurchase$ = getTurnoverAndPurchaseDataSource.data$();
  turnoverChargesServiceKind$ = getTurnoverChargesServiceKind.data$();
  turnoverChargesValo$ = getTurnoverChargesValo.data$();
  mostProfitableClients$ = getMostProfitableClients.data$();
  valoWeightByWasteFamily$ = getValoWeightByWasteFamily.data$();
  execCountPickup$ = getExecutionCountPickup.data$();
  execCountProcessing$ = getExecutionCountProcessingValo.data$();
  execCountOther$ = getExecutionCountOther.data$();
  execCountRenting$ = getExecutionCountRenting.data$();
  execCountAll$ = getExecutionCountAll.data$();
}

export const statisticsQuery = new StatisticsQuery();
